/**
 * RequireDeploymentSurface — the router-level B2C strip (P-B2B-1, Doc 25 §2).
 *
 * Doc 25 is explicit that hiding navigation is NOT sufficient: "Do not
 * conditionally hide navigation items alone — block the route itself." This
 * component is that block. It renders nothing; it watches the current path and
 * redirects a B2C workspace off any surface outside the allow-list.
 *
 * Deliberately conservative while the workspace list is still loading: with no
 * resolved workspace we do nothing, because guessing 'b2c' would bounce a B2B
 * user off a legitimate page on every cold load.
 *
 * The hook lives in `@/lib/useDeploymentMode` so this file exports only a
 * component (react-refresh/only-export-components, enforced at
 * --max-warnings=0 in CI).
 */

import { Navigate, useLocation } from 'react-router-dom';
import { deploymentRedirectFor } from '@/lib/deploymentMode';
import { useDeploymentMode } from '@/lib/useDeploymentMode';

export function RequireDeploymentSurface() {
  const location = useLocation();
  const { mode, resolved } = useDeploymentMode();

  // Never strip before we know which workspace we're in.
  if (!resolved) return null;

  const redirectTo = deploymentRedirectFor(mode, location.pathname);
  if (!redirectTo) return null;

  return <Navigate to={redirectTo} replace />;
}
